import React, { useEffect, useState, useRef } from 'react';
import { Button } from './ui/Button';
interface OTPVerificationProps {
  phone: string;
  onVerify: () => void;
  onBack: () => void;
}
export function OTPVerification({
  phone,
  onVerify,
  onBack
}: OTPVerificationProps) {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const [timer, setTimer] = useState(30);
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer(t => t - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);
  const handleChange = (index: number, value: string) => {
    if (value.length > 1) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  const handleKeyDown = (index: number, e: React.KeyboardEvent) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').slice(0, 6).split('');
    const newOtp = [...otp];
    pastedData.forEach((char, index) => {
      if (index < 6) newOtp[index] = char;
    });
    setOtp(newOtp);
    inputRefs.current[Math.min(pastedData.length, 5)]?.focus();
  };
  const isComplete = otp.every(digit => digit !== '');
  return <div className="space-y-6" data-id="element-300">
      <div data-id="element-301">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-302">
          Check your phone
        </h1>
        <p className="text-gray-600" data-id="element-303">
          We've sent a 6-digit code to{' '}
          <span className="font-semibold text-gray-900" data-id="element-304">+60 {phone}</span>
        </p>
        <button onClick={onBack} className="text-[#FFD700] text-sm font-medium mt-2 hover:underline" data-id="element-305">
          Change phone number
        </button>
      </div>

      <div className="space-y-8" data-id="element-306">
        <div className="flex justify-between gap-2" data-id="element-307">
          {otp.map((digit, index) => <input key={index} ref={el => inputRefs.current[index] = el} type="text" inputMode="numeric" maxLength={1} value={digit} onChange={e => handleChange(index, e.target.value)} onKeyDown={e => handleKeyDown(index, e)} onPaste={handlePaste} className="w-12 h-14 text-center text-2xl font-bold border border-gray-300 rounded-lg focus:border-[#FFD700] focus:ring-2 focus:ring-[#FFD700] focus:outline-none transition-all" data-id="element-308" />)}
        </div>

        <Button onClick={onVerify} fullWidth disabled={!isComplete} data-id="element-309">
          Verify Code
        </Button>

        <div className="text-center" data-id="element-310">
          {timer > 0 ? <p className="text-sm text-gray-500" data-id="element-311">
              Resend code in{' '}
              <span className="font-medium text-gray-900" data-id="element-312">{timer}s</span>
            </p> : <button onClick={() => setTimer(30)} className="text-sm font-medium text-[#FFD700] hover:underline" data-id="element-313">
              Resend code
            </button>}
        </div>
      </div>
    </div>;
}